<div class="bottom-sheet">
    <div class="text"> {{ data?.text }}</div>
    <div class="buttons-container">
        <button mat-button type="button" color="warn" (click)="clearBar()">{{ data?.declineOption }}</button>
        <button mat-button class="change" type="submit" color="warn" (click)="confirmOperation()">{{ data?.confirmOption }}</button>
    </div>
</div>